import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_COST_CENTERS](state, data) {
    console.log('mutation ', data)
    state.allCostCenters = data
  },
}
